import { FC, forwardRef } from 'react';

import ListItem from '@material-ui/core/ListItem';
import cx from 'classnames';

import { useHistory } from 'lib/common/hooks/useHistory';

export interface AppMenuItemComponentProps {
  testId: string;
  className?: string;
  link?: string | null;
  activeClassName?: string;
  pageHasSubMenu?: boolean;
  external?: boolean;
}

const NavLinkButton = (link, external, testId, activeClassName) => (props, ref) => {
  const { NavLink } = useHistory();

  if (external) {
    return <a {...props} href={link} innerRef={ref} rel="noreferrer" target="_blank" data-testid={testId} />;
  }

  return (
    <NavLink
      end
      {...props}
      to={link}
      innerRef={ref}
      data-testid={testId}
      className={({ isActive }) => cx(props.className, { [activeClassName]: isActive })}
    />
  );
};

const SidebarMenuComponent: FC<AppMenuItemComponentProps> = (props) => {
  const { className, link, children, activeClassName, external, testId } = props;

  return (
    <ListItem
      button
      className={cx(className, 'nav-item')}
      component={forwardRef(NavLinkButton(link, external, testId, activeClassName))}
      disableRipple
    >
      {children}
    </ListItem>
  );
};

export default SidebarMenuComponent;
